import React, { useState } from "react";
import styles from "./ImageCarousel.module.scss";
import PlaceHolder from "../../../../static/images/imagePlaceholder.svg";

export const ImageCarousel = ({ images = [], altText = "Product image" }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  if (!images.length) {
    return <div className={styles.carousel_placeholder}>{<img className={styles.carousel_image} src={PlaceHolder} alt="placeholder_image" />}</div>;
  }

  if (images.length === 1) {
    return (
      <div className={styles.carousel_single}>
        <img
          src={images[0]}
          alt={altText}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = PlaceHolder;
          }}
          loading="lazy"
        />
      </div>
    );
  }

  const goPrev = () => setActiveIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  const goNext = () => setActiveIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));

  return (
    <div className={styles.carousel}>
      <button type="button" className={`${styles.carousel_arrow} ${styles.carousel_arrow_left}`} onClick={goPrev} aria-label="Previous image">
        <i className="fa fa-chevron-left" aria-hidden="true"></i>
      </button>

      <img
        src={images[activeIndex]}
        alt={`${altText} ${activeIndex + 1} of ${images.length}`}
        className={styles.carousel_image}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = PlaceHolder;
        }}
        loading="lazy"
      />

      <button type="button" className={`${styles.carousel_arrow} ${styles.carousel_arrow_right}`} onClick={goNext} aria-label="Next image">
        <i className="fa fa-chevron-right" aria-hidden="true"></i>
      </button>

      <div className={styles.carousel_dots}>
        {images.map((_, idx) => (
          <button
            key={idx}
            type="button"
            className={`${styles.carousel_dot} ${idx === activeIndex ? styles.carousel_dot_active : ""}`}
            onClick={() => setActiveIndex(idx)}
            aria-label={`Go to image ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  );
};
